var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function({hover}){return [_c('app-icon',{staticClass:"component-container",attrs:{"color":hover ? 'white' : '',"icon":"close","title":"Close"}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }